import Phaser from 'phaser';
import { TEX } from '../ui/assets';

export function spawnFireflies(
  scene: Phaser.Scene,
  bounds: { x: number; y: number; w: number; h: number },
  count = 8,
): void {
  for (let i = 0; i < count; i++) {
    const x = bounds.x + Math.random() * bounds.w;
    const y = bounds.y + Math.random() * bounds.h;
    const dot = scene.add
      .image(x, y, TEX.vfxPollen)
      .setBlendMode(Phaser.BlendModes.ADD)
      .setScale(0.22 + Math.random() * 0.16)
      .setAlpha(0.75)
      .setDepth(3);
    scene.tweens.add({
      targets: dot,
      x: x + Phaser.Math.Between(-40, 40),
      y: y + Phaser.Math.Between(-22, 26),
      alpha: 0.2,
      angle: 40,
      duration: 1600 + Math.random() * 1400,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
  }
}

export function driftPetals(
  scene: Phaser.Scene,
  count = 7,
  bounds: { x: number; y: number; w: number; h: number } = { x: 20, y: 40, w: 680, h: 240 },
): void {
  for (let i = 0; i < count; i++) {
    const x = bounds.x + Math.random() * bounds.w;
    const y = bounds.y + Math.random() * bounds.h;
    const key = i % 2 === 0 ? TEX.vfxPetal : TEX.vfxLeaf;
    const img = scene.add.image(x, y, key).setDepth(4).setAlpha(0.9);
    img.setScale(0.4 + Math.random() * 0.25);
    scene.tweens.add({
      targets: img,
      x: x + Phaser.Math.Between(-24, 36),
      y: y + 70 + Math.random() * 50,
      angle: i % 2 === 0 ? 90 : -70,
      alpha: 0.25,
      duration: 3200 + Math.random() * 1800,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
  }
}
